module.exports = __webpack_public_path__ + "img/1542486215.caa95892.jpg";